import React from 'react'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import {
	Typography,
	FormControl,
	TextField,
	TextareaAutosize,
	FormControlLabel,
	Switch
} from '@material-ui/core'
import { DatePicker } from "@material-ui/pickers"
import ImageLoader from './../../containers/modules/ImageLoader'
import { Mcedit } from '../../containers/modules/Mcedit'
import { 
	get_query,
	post_query 
} from './../../functions'

const initState = {
	id: false,
	subject: '',
	viewdate: moment(),
	viewrecord: false,
	preview: '',
	preimg: '',
	content: ''
}

// new blog record
class BlogEdit extends React.Component {
	constructor(props){
		super(props)
		this.state = {
			loader: false
		}
	}

	UNSAFE_componentWillMount(){
		this.setState(Object.assign({}, this.state, initState))
	}

	componentDidMount(){
		this.getData()
	}

	// get record data
	getData(){
		this.setState({ loader: true })
		let id = this.props.match.params.id
		get_query(`/api/blogs/${id}`)
		.then((res) => {
			this.setState({
				id: res.id,
				subject: res.subject,
				preview: res.preview,
				preimg: res.preimg,
				viewdate: res.viewdate ? moment(res.viewdate, 'YYYY-MM-DD HH:mm:ss') : false,
				viewrecord: res.viewrecord,
				loader: false,
				content: res.content
			})
		})
		.catch((err) => {
			this.setState({ loader: false })
		})
	}

	// save record data
	saveData(content){
		this.setState({ loader: true })
		let data = {
			id: this.state.id,
			subject: this.state.subject,
			viewdate: this.state.viewdate.unix(),
			viewrecord: this.state.viewrecord,
			preview: this.state.preview,
			preimg: this.state.preimg,
			content: content
		}
		post_query('/api/blogs/update', data)
		.then((res) => {
			this.props.history.push(`/blog`)
		})
		.catch((err) => {
			this.setState({ loader: false })
		})
	}

	goBack(){
		this.props.history.push('/blog')
	}

	render(){
		return(
			<>
				<Typography variant='h4'>
					Редактировать статью в блог
				</Typography>
				<div className='div-flex-row'>
					<div
						style={{ padding: 16 }}
					>
						<ImageLoader 
							width={300}
							height={300}
							img={this.state.preimg}
							upload={(l) => this.setState({ preimg: l })}
						/>
					</div>
					<div className='fields'>
						<div>
							<FormControl
								className='form-item'
							>
								<TextField
									disabled={this.state.loader} 
									inputProps={{style:{ width: 700 }}}
									label='Тема статьи'
									value={this.state.subject}
									onChange={(ev) => this.setState({ subject: ev.target.value })}
								/>
							</FormControl>
						</div>
						<div>
							<FormControl
								className='form-item'
							>
								<DatePicker
									disabled={this.state.loader}
									openTo="year"
									format="DD-MM-YYYY"
									label="Начало действия"
									views={["date"]}
									value={this.state.viewdate}
									onChange={(viewdate) => this.setState({ viewdate: viewdate })}
								/>
							</FormControl>
						</div>
						<div>
							<FormControl
								className='form-item'
							>
								<TextareaAutosize
									disabled={this.state.loader}
									placeholder='Краткое описание'
									rowsMin={8}
									style={{ width: 700 }}
									label='Краткое описание'
									value={this.state.preview}
									onChange={(ev) => this.setState({ preview: ev.target.value })}
								/>
							</FormControl>
						</div>
						<div>
							<FormControlLabel
								value='start'
								control={
									<Switch
										disabled={this.state.loader} 
										color="primary" 
										checked={this.state.viewrecord}
										onChange={(ev) => this.setState({ viewrecord: ev.target.checked })}
									/>
								}
								label={this.state.viewrecord ? 
									<p style={{width: 120}}>Показано</p> : 
									<p style={{width: 120}}>Скрыто</p>
								}
								labelPlacement="start"
							/>
						</div>
					</div>
				</div>
				<Mcedit
					loader={this.state.loader}
					initialValue={this.state.content}
					goBack={() => this.goBack()}
					saveAction={(c) => this.saveData(c)}
				/>
			</>
		)
	}
}

export default withRouter(BlogEdit)


